<div class="min-h-screen">
  <app-shared-layout
    [Analysis]="title"
    [hideAdd]="true"
    [useBackButton]="false"
  >
    <div ngProjectAs="primary-panel" class="flex flex-col gap-10">
      <div class="w-full">
        <div
          class="grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-6 pb-2"
        >
          <!-- CARD 1: Total Alerts -->
          <div
            (click)="cardClicked('alert-today')"
            class="cursor-pointer group bg-red-50 p-4 rounded-xl shadow-md flex flex-col gap-2 h-full hover:shadow-lg transition-shadow"
          >
            <div class="flex items-center gap-2">
              <div class="p-2 bg-red-400 text-white rounded-full shadow-md">
                <img
                  src="assets/images/notification-02.png"
                  alt="alert"
                  class="w-5 h-5"
                />
              </div>
            </div>
            <div class="flex items-center gap-1 text-sm text-gray-600">
              <span>Total Alerts</span>
              <span class="text-xs">(Today)</span>
            </div>
            <div class="text-3xl font-bold text-red-600">
              {{ dashboardData?.ALERTS?.TOTAL_ALERTS }}
            </div>
            <div class="flex flex-wrap gap-1.5 mt-2">
              <span
                class="bg-green-600/80 text-white text-xs px-2.5 py-1 rounded-full whitespace-nowrap"
              >
                Resolved ({{ dashboardData?.ALERTS?.RESOLVED_ALERTS }})
              </span>
              <span
                class="bg-red-600 text-white text-xs px-2.5 py-1 rounded-full whitespace-nowrap"
              >
                Unresolved ({{ dashboardData?.ALERTS?.UNRESOLVED_ALERTS }})
              </span>
            </div>
          </div>

          <!-- CARD 2: Warehouse with Most Alerts -->
          <div
            (click)="cardClicked('alert')"
            class="cursor-pointer group bg-yellow-50 p-4 rounded-xl shadow-md flex flex-col gap-2 h-full hover:shadow-lg transition-shadow"
          >
            <div class="flex items-center gap-2">
              <div class="p-2 bg-yellow-400 text-white rounded-full shadow-md">
                <img
                  src="assets/images/notification-02.png"
                  alt="alert"
                  class="w-5 h-5"
                />
              </div>
            </div>
            <div class="text-sm text-gray-600">Warehouse with most Alert</div>

            @if (warehouseAlertCount?.alertsByWarehouse?.[0]) {
              <div class="text-3xl font-bold text-yellow-600">
                {{ warehouseAlertCount.alertsByWarehouse[0].alertsCount }}
              </div>
              <div
                class="bg-green-600/80 text-white text-xs px-2 py-1 rounded-full mt-3 truncate max-w-full"
              >
                Most Alert:
                <span
                  [title]="
                    warehouseAlertCount.alertsByWarehouse[0].warehouseName
                  "
                >
                  {{ warehouseAlertCount.alertsByWarehouse[0].warehouseName }}
                </span>
              </div>
            } @else {
              <div class="text-3xl font-bold text-yellow-600">0</div>
              <div
                class="bg-gray-300 text-white text-xs px-2 py-1 rounded-full mt-1"
              >
                No Data
              </div>
            }
          </div>

          <!-- CARD 3: Total Warehouses -->
          <div
            (click)="cardClicked('total')"
            class="cursor-pointer group bg-blue-50 p-4 rounded-xl shadow-md flex flex-col gap-2 h-full hover:shadow-lg transition-shadow"
          >
            <div class="flex items-center gap-2">
              <div class="p-2 bg-blue-400 text-white rounded-full shadow-md">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M3 9.75L12 3l9 6.75M4.5 10.5V21h15V10.5M9 21V12h6v9"
                  />
                </svg>
              </div>
            </div>
            <div class="text-sm text-gray-600">Total Warehouses</div>
            <div class="text-4xl font-bold text-blue-600">
              {{ dashboardData?.WAREHOUSES }}
            </div>
          </div>

          <!-- CARD 4: Total Sensors -->
          <div
            class="cursor-pointer group bg-purple-50 p-4 rounded-xl shadow-md flex flex-col gap-2 h-full hover:shadow-lg transition-shadow"
            (click)="cardClicked('sensor')"
          >
            <div class="flex items-center gap-2">
              <div class="p-2 bg-purple-400 text-white rounded-full shadow-md">
                <mat-icon class="text-white !text-xl">sensors</mat-icon>
              </div>
            </div>

            <div class="text-sm text-gray-600">Total Installed Sensors</div>

            <div class="text-4xl font-bold text-purple-600">
              {{ dashboardData?.SENSORS }}
            </div>

            <!-- STATUS BADGES -->
            <div class="flex flex-wrap items-center gap-2 mt-1">
              <span
                class="bg-green-600/80 text-white text-xs px-2.5 py-1 rounded-full whitespace-nowrap"
              >
                Active: {{ dashboardData?.SENSOR_STATUS?.TOTAL_ACTIVE_SENSORS }}
              </span>

              <span
                class="bg-red-600 text-white text-xs px-2.5 py-1 rounded-full whitespace-nowrap"
              >
                Inactive:
                {{ dashboardData?.SENSOR_STATUS?.TOTAL_INACTIVE_SENSORS }}
              </span>
            </div>
          </div>

          <!-- CARD 5: Temperature Stability -->
          <div
            (click)="cardClicked('temperature')"
            class="cursor-pointer group bg-orange-50 p-4 rounded-xl shadow-md flex flex-col gap-2 h-full hover:shadow-lg transition-shadow"
          >
            <div class="flex items-center gap-2">
              <div class="p-2 bg-orange-400 text-white rounded-full shadow-md">
                <img
                  src="assets/images/temperature.png"
                  alt="temp"
                  class="w-5 h-5"
                />
              </div>
            </div>
            <div class="text-sm text-gray-600">Temperature Stability</div>
            <div class="text-2xl font-bold text-orange-600">
              {{
                stabilityReadings?.length > 0
                  ? stabilityReadings[0]?.temperature_stability + "%"
                  : "No data"
              }}
            </div>
            @if (stabilityReadings?.[0]) {
              <div
                class="bg-green-600/80 text-white text-xs px-2 py-1 rounded-full mt-3 truncate"
              >
                Stable:
                <span [title]="stabilityReadings[0].warehouse_name">{{
                  stabilityReadings[0].warehouse_name
                }}</span>
              </div>
            }
          </div>

          <!-- CARD 6: Humidity Stability -->
          <div
            (click)="cardClicked('humidity')"
            class="cursor-pointer group bg-teal-50 p-4 rounded-xl shadow-md flex flex-col gap-2 h-full hover:shadow-lg transition-shadow"
          >
            <div class="flex items-center gap-2">
              <div class="p-2 bg-teal-400 text-white rounded-full shadow-md">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 2.25c-2.25 3-6.75 8.25-6.75 12a6.75 6.75 0 0013.5 0c0-3.75-4.5-9-6.75-12z"
                  />
                </svg>
              </div>
            </div>
            <div class="text-sm text-gray-600">Humidity Stability</div>
            <div class="text-2xl font-bold text-teal-600">
              {{
                stabilityReadings?.length > 0
                  ? stabilityReadings[0]?.humidity_stability + "%"
                  : "No data"
              }}
            </div>
            @if (stabilityReadings?.[0]) {
              <div
                class="bg-green-600/80 text-white text-xs px-2 py-1 rounded-full mt-3 truncate"
              >
                Stable:
                <span [title]="stabilityReadings[0].warehouse_name">{{
                  stabilityReadings[0].warehouse_name
                }}</span>
              </div>
            }
          </div>
        </div>
      </div>

      <!-- Graphs Section with Nude Colors & Animation -->
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 w-full mt-6">
        <div class="lg:col-span-1 bg-[#ffffff] p-6 rounded-xl shadow-lg">
          <div class="flex items-center justify-between mb-4 w-full">
            <div class="flex-1 text-start">
              <h3 class="font-bold text-xl text-primary py-1 leading-none">
                {{
                  currentView === "warehouse"
                    ? " Average Warehouse Humidity & Temperature for last six hours"
                    : "Zone Temperature and Humidity"
                }}
              </h3>
            </div>
            <button
              *ngIf="currentView === 'zone'"
              (click)="goBackToWarehouses()"
              class="bg-blue-500 hover:bg-blue-600 text-white font-medium py-1 px-2 rounded text-sm flex items-center"
            >
              ← Warehouses
            </button>
          </div>

          <div *ngIf="!loadingData && warehouseDashboardData?.length > 0">
            <apx-chart
              #chart
              [series]="barChart.series"
              [chart]="barChart.chart"
              [xaxis]="barChart.xaxis"
                 [yaxis]="barChart.yaxis"
              [plotOptions]="barChart.plotOptions"
              [dataLabels]="barChart.dataLabels"
              [colors]="barChart.colors"
              [stroke]="barChart.stroke"
            ></apx-chart>
          </div>

          <div
            class="flex justify-center gap-4 items-center"
            *ngIf="warehouseDashboardData?.length == 0"
          >
            <fa-icon
              class="text-2xl scale-110"
              [icon]="faCircleExclamation"
            ></fa-icon>
            <span class="font-semibold">No data</span>
          </div>
        </div>

        <!-- Alert distribution chart (takes 1/3 on large screens) -->
        <div class="lg:col-span-1 bg-[#ffffff] p-6 rounded-xl shadow-lg">
          <h3 class="font-bold text-xl text-primary text-start mb-4">
            Alert Distribution
          </h3>

          <div
            *ngIf="
              !loadingData &&
              alertCounts?.length > 0 &&
              radialChart.series?.length
            "
          >
            <apx-chart
              [series]="radialChart.series"
              [chart]="radialChart.chart"
              [labels]="radialChart.labels"
              [plotOptions]="radialChart.plotOptions"
              [colors]="radialChart.colors"
            ></apx-chart>
          </div>

          <div
            class="flex justify-center gap-4 items-center"
            *ngIf="alertCounts.length == 0"
          >
            <fa-icon
              class="text-2xl scale-110"
              [icon]="faCircleExclamation"
            ></fa-icon>
            <span class="font-semibold">No data</span>
          </div>
        </div>

        <div class="bg-white p-6 rounded-xl shadow-lg">
          <h3 class="font-bold text-xl mb-4 text-primary">
            Warehouse InStability
          </h3>

          <app-bar-graph
            chart_type="bar"guest
            [xAxis]="unstableLabels"
            [data]="unstableSeries"
            [colors]="unstableColors"
            title="Top 5 Most Unstable Warehouses"
            titleAlign="center"
            LegendPosition="bottom"
             xAxisTitle="Warehouse Name"
             yAxisTitle="Instability Value (%)"
            [showXlabel]="true"
            [showYlabel]="true"
          >
          </app-bar-graph>
        </div>
      </div>

      <div
        class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mt-6"
      >
        <div
          *ngFor="let item of warehouseAlertCount?.alertsByWarehouse"
          class="flex flex-col justify-between bg-gray-50 p-6 rounded-2xl shadow-md text-gray-800 hover:shadow-lg transition-all duration-200"
        >
          <div class="flex items-center gap-3 mb-3">
            <img
              src="assets/images/activity-03.png"
              alt="alert"
              class="w-8 h-8 font-normal"
            />
            <div class="text-lg font-normal break-words">
              {{ item.warehouseName }}
            </div>
          </div>

          <div class="text-sm text-gray-500 font-medium">
            {{ item.alertsCount }} Alerts
          </div>
        </div>
      </div>
    </div>
  </app-shared-layout>
</div>
